import { Option } from '../../../types/form-types';

const countryData = require('./country.json');
const brandData = require('./brandeurotax.json');
const carlineData = require('./lcvmodelosoriginalfest.json');

export const getCountryName = (countryCode: string | undefined | null): string => {
	if (!countryCode || countryCode.trim() === '') {
		return '';
	}

	const foundCountry = (countryData as any).content.find((country: any) =>
		country.attributes.find((attr: any) => attr.name === 'CODIGO' && attr.value === countryCode),
	);
	return foundCountry?.attributes.find((attr: any) => attr.name === 'PAIS_CASTELLANO')?.value || '';
};

export const getCountryCode = (countryName: string | undefined | null): string => {
	if (!countryName || countryName.trim() === '') {
		return '';
	}

	const foundCountry = (countryData as any).content.find((country: any) =>
		country.attributes.find((attr: any) => attr.name === 'PAIS_CASTELLANO' && attr.value === countryName),
	);
	return foundCountry?.attributes.find((attr: any) => attr.name === 'CODIGO')?.value || '';
};

export const getCarlineName = (carlineCode: string | undefined | null): string => {
	if (!carlineCode || carlineCode.trim() === '') {
		return '';
	}

	// Buscar en lcvmodelosoriginalfest.json primero
	const foundCarline = (carlineData as any).content.find((carline: any) =>
		carline.attributes.find((attr: any) => attr.name === 'CODE' && attr.value === carlineCode),
	);

	if (foundCarline) {
		return foundCarline.attributes.find((attr: any) => attr.name === 'NAME')?.value || '';
	}

	// Si no se encuentra, buscar en brandeurotax.json como fallback
	const foundBrand = (brandData as any).content.find((brand: any) =>
		brand.attributes.find((attr: any) => attr.name === 'CODE' && attr.value === carlineCode),
	);

	return foundBrand?.attributes.find((attr: any) => attr.name === 'NAME')?.value || '';
};

export const getCarlineCode = (carlineName: string | undefined | null): string => {
	if (!carlineName || carlineName.trim() === '') {
		return '';
	}

	// Buscar en lcvmodelosoriginalfest.json primero
	const foundCarline = (carlineData as any).content.find((carline: any) =>
		carline.attributes.find((attr: any) => attr.name === 'NAME' && attr.value === carlineName),
	);

	if (foundCarline) {
		return foundCarline.attributes.find((attr: any) => attr.name === 'CODE')?.value || '';
	}

	// Si no se encuentra, buscar en brandeurotax.json como fallback
	const foundBrand = (brandData as any).content.find((brand: any) =>
		brand.attributes.find((attr: any) => attr.name === 'NAME' && attr.value === carlineName),
	);

	return foundBrand?.attributes.find((attr: any) => attr.name === 'CODE')?.value || '';
};

export const getCountries = (): Array<Option | string> => {
	return countryData.content.map((item: any) => ({
		text: item.attributes.find((attr: any) => attr.name === 'PAIS_CASTELLANO')?.value || '',
		value: item.attributes.find((attr: any) => attr.name === 'CODIGO')?.value || '',
	}));
};

export const getBrands = (): Array<Option | string> => {
	const allowedBrands = [
		'CITROEN',
		'FIAT',
		'FORD',
		'MERCEDES-BENZ',
		'NISSAN',
		'OPEL',
		'PEUGEOT',
		'RENAULT',
		'TOYOTA',
		'KIA',
		'HYUNDAI',
		'HONDA',
	];
	return brandData.content
		.filter((item: any) => {
			const name = item.attributes.find((attr: any) => attr.name === 'NAME')?.value || '';
			return allowedBrands.includes(name);
		})
		.map((item: any) => {
			const name = item.attributes.find((attr: any) => attr.name === 'NAME')?.value || '';
			return {
				text: name.charAt(0).toUpperCase() + name.slice(1).toLowerCase(),
				value: item.attributes.find((attr: any) => attr.name === 'CODE')?.value || '',
			};
		});
};

export const getModels = (): Array<Option | string> => {
	return carlineData.content.map((item: any) => ({
		text: item.attributes.find((attr: any) => attr.name === 'NAME')?.value || '',
		value: item.attributes.find((attr: any) => attr.name === 'CODE')?.value || '',
	}));
};

export const getValidModel = (model?: string): string => {
	if (!model) return '';
	const models = getModels() as Option[];
	return models.find((m) => m.text?.toLowerCase() == model.replace(/nuevo/gi, '').trim().toLowerCase())?.text || '';
};

// Metodos por si necesitamos obtener el texto del value seleccionado

export const getCountryTextByValue = (code: string): string => {
	const countries = getCountries() as Option[];
	return countries.find((country) => country.value === code)?.text || '';
};

export const getModelTextByValue = (code: string): string => {
	const models = getModels() as Option[];
	return models.find((model) => model.value === code)?.text || '';
};

export const getBrandTextByValue = (code: string): string => {
	const brands = getBrands() as Option[];
	return brands.find((brand) => brand.value === code)?.text || '';
};
